<script setup lang="ts">
import { isDecimal } from "../../utils";

const props = withDefaults(defineProps<{
    id: string,
    modelValue: number,
    hidePii?: boolean,
}>(), {
    hidePii: true,
    modelValue: 0,
});

const add = () => props.modelValue + 1;
const subtract = () => (props.modelValue <= 0 || props.modelValue - 1 < 0) ? 0 : props.modelValue - 1;

defineOptions({
    inheritAttrs: false,
});

const emit = defineEmits<{
    (on:"update:modelValue", value: number): void
    (on:"blur", value: number): void
}>();

</script>
<template>
    <div
        class="auto-col"
    >
        <div class="input-group">
            <button
                class="input-group-text"
                @click="emit('update:modelValue', subtract())"
            >
                -
            </button>
            <input
                :id="id"
                :value="modelValue"
                type="number"
                inputmode="decimal"
                :max="999"
                :min="0"
                :class="[{
                    input: true,
                    sessioncamhidetext: hidePii,
                },
                ]"
                class="form-control"
                placeholder="0"
                v-bind="$attrs"
                @paste="isDecimal"
                @keypress="isDecimal"
                @input="emit('update:modelValue', Number(($event.target as HTMLInputElement).value))"
            >
            <button
                class="input-group-text"
                @click="emit('update:modelValue', add())"
            >
                +
            </button>
        </div>
    </div>
</template>
<style scoped>
    button {
        touch-action: manipulation;
    }
</style>
